import { render, staticRenderFns } from "./IndividualCustomer.vue?vue&type=template&id=1c9bb199&scoped=true&"
import script from "./IndividualCustomer.vue?vue&type=script&lang=js&"
export * from "./IndividualCustomer.vue?vue&type=script&lang=js&"
import style0 from "./IndividualCustomer.vue?vue&type=style&index=0&id=1c9bb199&lang=scss&scoped=true&"
import style1 from "./IndividualCustomer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9bb199",
  null
  
)

export default component.exports